import {Injectable} from '@angular/core';
import {ModalService} from '../modal-service.service';
import {AlertModalComponent, CssClass} from './alert-modal.component';

@Injectable({
    providedIn: 'root'
})
export class AlertModalService extends ModalService {
    createAlertMessage(
        message: string | string[],
        buttonLabel?: string,
        title?: string,
        cssClass?: CssClass,
        formValidationMessages?: string[],
        formValidationTitle?: string,
        buttonTooltip?: string,
        modalSize?: 'sm' | 'md' | 'lg'
    ) {
        this.createModalComponent(AlertModalComponent);
        // cast it to the Modal Component you are working on.
        const alertModalComponentInstance = this.modalComponentRef.instance as AlertModalComponent;

        if (title) {
            alertModalComponentInstance.setTitle(title);
        }
        if (buttonTooltip && buttonLabel) {
            alertModalComponentInstance.initButtons(buttonLabel, null, null, null, buttonTooltip);
        } else if (buttonLabel) {
            alertModalComponentInstance.initButtons(buttonLabel);
        }
        if (cssClass) {
            alertModalComponentInstance.initCssClass(cssClass);
        }
        if (formValidationMessages) {
            alertModalComponentInstance.addFormValidationMessages(formValidationMessages);
        }
        if (formValidationTitle) {
            alertModalComponentInstance.setTitle(formValidationTitle); // override default title settings
        }

        alertModalComponentInstance.alertModalMessages.length = 0;

        if (message) {
            if (!Array.isArray(message)) {
                alertModalComponentInstance.addMessage(message);
            } else {
                message.forEach(msg => {
                    alertModalComponentInstance.addMessage(msg);
                });
            }
        }

        return this.createAlert(modalSize);
    }

    createAlert(modalSize: 'sm' | 'md' | 'lg' = 'md') {
        if (this.modalOpen) {
            console.debug('Modal already opened.');
            return null;
        } else {
            const alertModalComponentInstance = this.modalComponentRef.instance as AlertModalComponent;

            if (!alertModalComponentInstance.isAlertModalHasValidParameters()) {
                console.log('Invalid modal parameters.');

                this.modalOpen = false;
                return null;
            }
            this.modalComponentRef.setInput('modalSize', `modal-${modalSize}`);

            this.showModalComponent();
            return alertModalComponentInstance.modalClosed;
        }
    }
}
